<div #benefitsFullscreen class="h-dvh w-screen bg-black/70 backdrop-blur-lg overflow-hidden opacity-0 transition-opacity px-4 py-6 md:px-8 md:py-8">

    <!-- INNER CONTAINER -->
    <div class="flex h-full w-full flex-col">
        
        <!-- HEADER -->
        <div class="grid grid-cols-[40px_1fr_40px] items-center gap-x-3 mb-6 xl:mb-8">

            <div></div>
            <div class="min-w-0">
                <h3 class="truncate text-white text-xl font-bold text-center">
                    {{title}}                    
                </h3>
            </div>
            <div>
                
                <app-button
                    (event)="toggleContainer(false)"
                    [custom]="['bg-semiblack hover:bg-white size-10 flex items-center justify-center p-0']"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                    </svg>

                </app-button>
                
            </div>

        </div>

        <!-- CAROUSEL -->
            <div class="flex min-h-0 w-full max-w-[1000px] flex-1 flex-col items-center justify-center gap-y-6 mx-auto">
                
                <div class="carousel fullscreen-carousel flex min-h-0 w-full flex-1 items-center justify-center">
        
                    <div class="splide" #carousel>
                        <div class="splide__track">
                            <ul class="splide__list">
                                @for (image of images; track $index) {
                                    <li class="splide__slide">
                                        <img [src]="image" [alt]="'Slide image'" class="carousel-image rounded-2xl" (load)="refreshCarousel()" (error)="refreshCarousel()">
                                    </li>
                                }
                            </ul>
                        </div>
                    </div>
            
                </div>
    
                <div [class]="total === 1 ? 'justify-center' : 'justify-between'" class="flex shrink-0 gap-x-4 px-2 w-full text-white text-sm">
                    
                    @if(splide){
                        <p class="max-w-[412px]" [innerHTML]="text"></p>
                    }
                    
                    @if (total !== 1) {
                        <p>
                            {{index}} / {{total}}
                        </p>
                    }
    
                </div>
    
            </div>
            
        

    </div>
   
</div>
